import { format } from "date-fns";

// table body templates that only depend on the row

export const kendaraanBodyTemplate = (row) => {
  if (row.data_trailer && row.data_trailer.nomor) return row.data_trailer.nomor;
  if (row.data_kendaraan && row.data_kendaraan.nomor_polisi)
    return row.data_kendaraan.nomor_polisi;
  return "-";
};

export const jenisBodyTemplate = (row) => {
  if (row.data_trailer && row.data_trailer.nomor) return "Trailer";
  if (row.data_kendaraan && row.data_kendaraan.jenis_mobil)
    return row.data_kendaraan.jenis_mobil;
  return "-";
};

// "Kendaraan / Jenis" column: both with a label (same look as the "Group / Keterangan" column)
export const kendaraanJenisBodyTemplate = (row) => (
  <div className="flex flex-col gap-1">
    <div className="flex flex-col">
      <span className="text-xs font-bold uppercase text-slate-400">
        Kendaraan
      </span>
      <span>{kendaraanBodyTemplate(row)}</span>
    </div>
    <div className="flex flex-col">
      <span className="text-xs font-bold uppercase text-slate-400">Jenis</span>
      <span>{jenisBodyTemplate(row)}</span>
    </div>
  </div>
);

// "Group / Keterangan" column: both with a label. groupText is the label_grup as text (formatLabelGrup of the variant).
export const groupKeteranganBodyTemplate = (row, groupText) => (
  <div className="flex flex-col gap-1">
    <div className="flex flex-col">
      <span className="text-xs font-bold uppercase text-slate-400">Group</span>
      <span>{groupText || "-"}</span>
    </div>
    <div className="flex flex-col">
      <span className="text-xs font-bold uppercase text-slate-400">
        Keterangan
      </span>
      <span>{row.keterangan || "-"}</span>
    </div>
  </div>
);

export const tanggalBodyTemplate = (row) => {
  return (
    <div className="col-center-center">
      <span className={`${row.tanggal_selesai ? "text-sm font-semibold" : ""}`}>
        {row.tanggal ? format(new Date(row.tanggal), "dd/MM/yyyy") : "-"}
      </span>
      {row.tanggal_selesai && (
        <span className={`text-sm font-semibold text-green-500`}>
          {format(new Date(row.tanggal_selesai), "dd/MM/yyyy")}
        </span>
      )}
    </div>
  );
};

export const durasiBodyTemplate = (row) => {
  let dayCountToToday = 0;
  const toDate = row.tanggal_selesai
    ? new Date(row.tanggal_selesai)
    : new Date();
  dayCountToToday = Math.floor(
    (toDate - new Date(row.tanggal)) / (1000 * 60 * 60 * 24)
  );
  return `${dayCountToToday.toLocaleString("id-ID")} hari`;
};

// "Dashboard" column. The dashboard shows a problem when "Show Dashboard" is on
// and nobody has handled it yet (Di tangani and Di tangani Tanggal are empty).
export const dashboardBodyTemplate = (row) => {
  let badge = {
    className: "bg-green-100 text-green-700",
    icon: "pi pi-eye",
    label: "Tampil",
  };
  if (!row.show_dashboard) {
    badge = {
      className: "bg-slate-100 text-slate-500",
      icon: "pi pi-eye-slash",
      label: "Disembunyikan",
    };
  } else if (row.di_tangani_id || row.di_tangani_datetime) {
    badge = {
      className: "bg-amber-100 text-amber-700",
      icon: "pi pi-check",
      label: "Sudah ditangani",
    };
  }

  return (
    <span
      className={`row-start-center gap-1 rounded-full px-2 py-0.5 text-xs font-semibold w-fit ${badge.className}`}
    >
      <i className={`${badge.icon} !text-xs`}></i>
      {badge.label}
    </span>
  );
};

// "Ditangani" column: both with a label (same look as the other columns).
// Ditangani: who handled it and when. Note: the note of the problem.
export const diTanganiBodyTemplate = (row) => {
  return (
    <div className="flex flex-col gap-1">
      <div className="flex flex-col">
        <span className="text-xs font-bold uppercase text-slate-400">
          Ditangani
        </span>
        <span>{row.data_di_tangani ? row.data_di_tangani.nama : "-"}</span>
        {row.di_tangani_datetime && (
          <span className="text-sm">{row.di_tangani_datetime}</span>
        )}
      </div>
      <div className="flex flex-col">
        <span className="text-xs font-bold uppercase text-slate-400">Note</span>
        <span>{row.note || "-"}</span>
      </div>
    </div>
  );
};
